import dynamic from 'next/dynamic';
import css from './index.module.scss';
import A from './components/A';
import EfScrollAni from '@/efscrollani';

const IndexDynamic = dynamic(() => import('./indexDynamic'), { ssr: true });
export default function CaseStudyH5() {
    if (typeof window !== 'undefined' && !window.AniContainer) {
        window.AniContainer = new EfScrollAni();
    }
    return (
        <div className={`case-study ${css['case-study']}`}>
            <A />
            <IndexDynamic />
        </div>
    );
}
